import { splitSubListByValue } from '../../../utils/utils'
import { getItemsByListCode } from 'isotope-client/modules/valueList/services/valueListSelectors'

const getList = function getList(state, id) {
	return getItemsByListCode(state)[id]
}

export const getFilteredLists = (state, valueParent, codeListToFilter) =>
	splitSubListByValue(valueParent, getList(state, codeListToFilter))
